// Sector names follow GICS; the short industry labels are editorial groupings for FactWeb.
export const STOCK_SECTORS = {
    정보기술: ["반도체", "소프트웨어", "IT서비스", "하드웨어", "전자부품"],
    커뮤니케이션: ["통신", "플랫폼", "미디어", "게임", "엔터"],
    경기소비재: ["자동차", "자동차부품", "의류", "내구재", "호텔레저", "외식", "유통"],
    필수소비재: ["식품", "음료", "담배", "생활용품", "식품유통"],
    헬스케어: ["제약", "바이오", "의료기기", "의료서비스"],
    금융: ["은행", "보험", "증권", "자산운용", "결제"],
    산업재: ["항공방산", "기계", "전기장비", "건설", "운송", "사업서비스"],
    에너지: ["석유가스", "에너지장비"],
    소재: ["화학", "철강", "비철금속", "건자재", "종이포장"],
    유틸리티: ["전력", "가스", "수도", "복합유틸"],
    부동산: ["리츠", "부동산개발", "부동산운영"],
} as const;

export type StockSector = keyof typeof STOCK_SECTORS;
export const STOCK_SECTOR_KEYS = Object.keys(STOCK_SECTORS) as StockSector[];

export const CATEGORY_GROUPS = {
    사회: ["뉴스", "사회", "문화", "교육", "직업", "생활", "연예"],
    정치: ["정치", "외교"],
    경제: ["경제", "금융", "산업", "부동산"],
    주식: STOCK_SECTOR_KEYS,
    과학: ["과학", "기술"],
    의료: ["의료", "건강"],
    환경: ["환경", "기후"],
    법률: ["법", "제도"],
    데이터: ["스포츠", "통계"],
    역사: ["역사", "사건"],
} as const;

export type CategoryGroup = keyof typeof CATEGORY_GROUPS;
export const CATEGORY_KEYS = Object.keys(CATEGORY_GROUPS) as CategoryGroup[];
export const CATEGORY_LIST = CATEGORY_KEYS.filter(group => group !== "주식")
    .flatMap(group => [...CATEGORY_GROUPS[group]]);

export const stockCategory = (sector: StockSector, industry?: string): string =>
    ["주식", sector, industry].filter(Boolean).join("/");

export function parseStockCategory(category?: string | null) {
    if (!category?.startsWith("주식/")) return null;
    const [group, sector, industry, extra] = category.split("/");
    if (extra !== undefined || !Object.prototype.hasOwnProperty.call(STOCK_SECTORS, sector)) return null;
    const key = sector as StockSector;
    if (industry !== undefined && !STOCK_SECTORS[key].some(item => item === industry)) return null;
    return {group, sector: key, industry};
}

export function categoryLabel(category?: string | null): string {
    const stock = parseStockCategory(category);
    return stock ? stock.industry || stock.sector : category || "";
}

export function categoryPath(category?: string | null): string {
    const stock = parseStockCategory(category);
    return stock ? [stock.group, stock.sector, stock.industry].filter(Boolean).join(" › ") : category || "";
}

export function categoryGroup(category?: string | null): CategoryGroup | undefined {
    if (category === "주식" || parseStockCategory(category)) return "주식";
    return CATEGORY_KEYS.find(group => group !== "주식" && CATEGORY_GROUPS[group].some(item => item === category));
}
